export function ketchPrefs() {
    (function() {
        //Call from Footer link
        $('.open-ketch-prefs').on('click', function(e) {
            e.preventDefault();
            ketch('showPreferences');
        });
    })();
}
